const path = "redux/Settings";
export const GET_SETTINGS = `${path}/GET_SETTINGS`;
export const UPDATE_SINGLE_SETTING = `${path}/UPDATE_ONE_SETTING`;
export const UPDATE_ARRAY_SETTING = `${path}/UPDATE_MULTIPLE_SETTINGS`;
export const UPDATE_MULTIPLE_SETTINGS = `${path}/UPDATE_MULTIPLE_SETTINGS`;
